import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Global route redirect handler.
 * Fetches admin-managed redirects and, when the current path matches an enabled
 * external redirect, replaces window.location to the destination.
 * Internal-CMS-mode redirects fall through to the SPA route.
 */
export default function RedirectHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    api.get("/redirects").then(({ data }) => {
      if (cancelled) return;
      const match = data.find(
        (r) => r.enabled && r.mode === "external" && r.source_path === pathname
      );
      if (match) {
        if (match.open_new_tab) {
          window.open(match.destination_url, "_blank", "noopener,noreferrer");
          window.history.back();
        } else {
          window.location.replace(match.destination_url);
        }
      }
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [pathname]);

  return null;
}
